import actionConstants from '../constants/';
import { matchesApiCancelKey } from '../apiCancelKeys';

const CLEARED_REQUEST_ID = '@settings/CLEARED_REQUEST';

const getActiveWebhookEvents = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
};

const getCheckoutVersionState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
};

const getMerchentSettings = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
};

const updateMerchentGeneralSettings = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
};

const updateMerchentWebhookData = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
};

const getV3MerchantWebhookData = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
};

const updateV3MerchantWebhookData = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
};

const activeUsers = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
  activeUserCount: 0,
};

const allPermissions = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
};

const allRoles = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
};

const createNewUserState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
};

const updateUserState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
};

const deleteUserState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
};

const createNewRoleState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  responseCode: 0,
  data: {},
  errorMessage: '',
};

const resendInvitationState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
};

const getCheckoutThemeState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
};

const updateCheckoutThemeState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
};

const updateDashboardThemeState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
};

const getDashboardThemeState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
};

const updateTPVState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  opCode: 0,
};

const caseManagementState = {
  access_token: '',
  expiresIn: '',
  tokenType: '',
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  error_code: '',
  error_message: '',
};

const ticketListState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  data: {},
  errorCode: 0,
  errorMessage: '',
};

const createTicketState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  data: {},
  errorCode: 0,
  errorMessage: '',
};

const uploadDocumentState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  data: {},
  errorCode: 0,
  errorMessage: '',
};

const linkDocumentTicketState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  data: {},
  errorCode: 0,
  errorMessage: '',
};

const categoryListState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  data: {},
  errorCode: 0,
  errorMessage: '',
};

const subcategoryListState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  data: {},
  errorCode: 0,
  errorMessage: '',
};

const caseCommentState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  data: {},
  errorCode: 0,
  errorMessage: '',
};

const addCommentState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  data: {},
  errorCode: 0,
  errorMessage: '',
};

const ticketDetailState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  data: {},
  errorCode: 0,
  errorMessage: '',
};

const attachmentDetailState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  data: {},
  errorCode: 0,
  errorMessage: '',
};

const fetchOffersRule = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
};

const setOffersRule = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
};

const getActiveEdgePaymentLinksWebhookEvents = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
};

const updateEdgePaymentLinksWebhookData = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
};

const updateMerchantVersionData = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
  activeRequestId: '',
};


const downloadCsrApplePayState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
};


const getApplePayWalletStatusState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
};

const getApplePayIntegrationStatusState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
};

const getApplePayWebRegistrationState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
};

const getApplePayCertificateActivationState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
};

const getPaymentModesState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
};

const initialState = {
  activeWebhookEvents: { ...getActiveWebhookEvents },
  activeEdgePaymentLinksEvents: { ...getActiveEdgePaymentLinksWebhookEvents },
  updateEdgePaymentLinksWebhook: {...updateEdgePaymentLinksWebhookData},
  merchentSettings: { ...getMerchentSettings },
  updateGeneralSettings: { ...updateMerchentGeneralSettings },
  updateMerchentWebhook: { ...updateMerchentWebhookData },
  v3MerchantWebhook: { ...getV3MerchantWebhookData },
  updateV3MerchantWebhook: { ...updateV3MerchantWebhookData },
  activeUsersList: { ...activeUsers },
  allPermissions: { ...allPermissions },
  allRoles: { ...allRoles },
  createNewUserState: { ...createNewUserState },
  createNewRoleState: { ...createNewRoleState },
  updateUserState: { ...updateUserState },
  deleteUserState: { ...deleteUserState },
  resendInvitationState: { ...resendInvitationState },
  getCheckoutThemeState: { ...getCheckoutThemeState },
  updateCheckoutThemeState: { ...updateCheckoutThemeState },
  getDashboardThemeState: { ...getDashboardThemeState },
  updateDashboardThemeState: { ...updateDashboardThemeState },
  updateTPVState: { ...updateTPVState },
  caseManagementState: { ...caseManagementState },
  ticketListState: { ...ticketListState },
  categoryListState: { ...categoryListState },
  subcategoryListState: { ...subcategoryListState },
  uploadDocumentState: { ...uploadDocumentState },
  createTicketState: { ...createTicketState },
  linkDocumentTicketState: { ...linkDocumentTicketState },
  caseCommentState: { ...caseCommentState },
  addCommentState: { ...addCommentState },
  ticketDetailState: { ...ticketDetailState },
  attachmentDetailState: { ...attachmentDetailState },
  fetchOffersRule: { ...fetchOffersRule },
  setOffersRule: { ...setOffersRule },
  updateMerchantVersionData: { ...updateMerchantVersionData },
  getCheckoutVersionState: { ...getCheckoutVersionState },
  hasMerchantTransactedState: {
    isLoading: false,
    isSuccess: false,
    isFailure: false,
    hasTransacted: null as boolean | null,
  },
  downloadCsrApplePayState: { ...downloadCsrApplePayState },
  getApplePayWalletStatusState: { ...getApplePayWalletStatusState },
  getApplePayIntegrationStatusState: { ...getApplePayIntegrationStatusState },
  getApplePayWebRegistrationState: { ...getApplePayWebRegistrationState },
  getApplePayCertificateActivationState: { ...getApplePayCertificateActivationState },
  getPaymentModes: { ...getPaymentModesState },
};

const isStaleResponse = (
  activeRequestId: string,
  responseRequestId?: string
) => Boolean(activeRequestId && activeRequestId !== responseRequestId);

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function settingsReducer(state = initialState, action) {
  switch (action.type) {
    case actionConstants.CANCEL_API_REQUEST:
      return {
        ...state,
        ...(matchesApiCancelKey(
          action.payload,
          actionConstants.GET_ACTIVE_WEBHOOK_EVENTS
        )
          ? {
              activeWebhookEvents: {
                ...state.activeWebhookEvents,
                isLoading: false,
              },
            }
          : {}),
        ...(matchesApiCancelKey(
          action.payload,
          actionConstants.GET_V3_MERCHANT_WEBHOOK
        )
          ? {
              v3MerchantWebhook: {
                ...state.v3MerchantWebhook,
                isLoading: false,
              },
            }
          : {}),
        ...(matchesApiCancelKey(
          action.payload,
          actionConstants.GET_ACTIVE_EDGE_PAYMENTS_LINKS_WEBHOOK_EVENTS
        )
          ? {
              activeEdgePaymentLinksEvents: {
                ...state.activeEdgePaymentLinksEvents,
                isLoading: false,
              },
            }
          : {}),
        ...(matchesApiCancelKey(
          action.payload,
          actionConstants.GET_CHECKOUT_THEME
        )
          ? {
              getCheckoutThemeState: {
                ...state.getCheckoutThemeState,
                isLoading: false,
              },
            }
          : {}),
        ...(matchesApiCancelKey(
          action.payload,
          actionConstants.GET_CHECKOUT_VERSION
        )
          ? {
              getCheckoutVersionState: {
                ...state.getCheckoutVersionState,
                isLoading: false,
              },
            }
          : {}),
        ...(matchesApiCancelKey(
          action.payload,
          actionConstants.GET_APPLE_PAY_WALLET_STATUS
        )
          ? {
              getApplePayWalletStatusState: {
                ...state.getApplePayWalletStatusState,
                isLoading: false,
              },
            }
          : {}),
        ...(matchesApiCancelKey(
          action.payload,
          actionConstants.GET_APPLE_PAY_INTEGRATION_STATUS
        )
          ? {
              getApplePayIntegrationStatusState: {
                ...state.getApplePayIntegrationStatusState,
                isLoading: false,
              },
            }
          : {}),
        ...(matchesApiCancelKey(action.payload, actionConstants.GET_PAYMENT_MODES)
          ? {
              getPaymentModes: {
                ...state.getPaymentModes,
                isLoading: false,
              },
            }
          : {}),
        ...(matchesApiCancelKey(
          action.payload,
          actionConstants.POST_UPDATE_MERCHANT_VERSION
        )
          ? {
              updateMerchantVersionData: {
                ...state.updateMerchantVersionData,
                isLoading: false,
                activeRequestId: CLEARED_REQUEST_ID,
              },
            }
          : {}),
      };

    case actionConstants.GET_PAYMENT_MODES_REQUEST:
      return {
        ...state,
        getPaymentModes: {
          ...state.getPaymentModes,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
        },
      };
    case actionConstants.GET_PAYMENT_MODES_SUCCESS:
      return {
        ...state,
        getPaymentModes: {
          ...state.getPaymentModes,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
        },
      };
    case actionConstants.GET_PAYMENT_MODES_FAILURE:
      return {
        ...state,
        getPaymentModes: {
          ...state.getPaymentModes,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          errorCode: action.payload.errorCode,
          errorMessage: action.payload.errorMessage,
        },
      };
    case actionConstants.GET_PAYMENT_MODES_CLEAR:
      return {
        ...state,
        getPaymentModes: {
          ...initialState.getPaymentModes,
          data: {},
        },
      };

    case actionConstants.ACTIVATE_APPLE_PAY_CERTIFICATE_REQUEST:
      return {
        ...state,
        getApplePayCertificateActivationState: {
          ...state.getApplePayCertificateActivationState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
        },
      };
    case actionConstants.ACTIVATE_APPLE_PAY_CERTIFICATE_SUCCESS:
      return {
        ...state,
        getApplePayCertificateActivationState: {
          ...state.getApplePayCertificateActivationState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
        },
      };
    case actionConstants.ACTIVATE_APPLE_PAY_CERTIFICATE_FAILURE:
      return {
        ...state,
        getApplePayCertificateActivationState: {
          ...state.getApplePayCertificateActivationState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
        },
      };
    case actionConstants.ACTIVATE_APPLE_PAY_CERTIFICATE_CLEAR:
      return {
        ...state,
        getApplePayCertificateActivationState: {
          ...initialState.getApplePayCertificateActivationState,
          data: {},
        },
      };

    case actionConstants.WEB_REGISTRATION_APPLE_PAY_REQUEST:
      return {
        ...state,
        getApplePayWebRegistrationState: {
          ...state.getApplePayWebRegistrationState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
        },
      };
    case actionConstants.WEB_REGISTRATION_APPLE_PAY_SUCCESS:
      return {
        ...state,
        getApplePayWebRegistrationState: {
          ...state.getApplePayWebRegistrationState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
          // errorCode: action.payload.OpCode,
        },
      };
    case actionConstants.WEB_REGISTRATION_APPLE_PAY_FAILURE:
      return {
        ...state,
        getApplePayWebRegistrationState: {
          ...state.getApplePayWebRegistrationState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          // errorCode: action.payload.OpCode,
        },
      };
    case actionConstants.WEB_REGISTRATION_APPLE_PAY_CLEAR:
      return {
        ...state,
        getApplePayWebRegistrationState: {
          ...initialState.getApplePayWebRegistrationState,
          data: {},
        },
      };

    case actionConstants.GET_APPLE_PAY_INTEGRATION_STATUS_REQUEST:
      return {
        ...state,
        getApplePayIntegrationStatusState: {
          ...state.getApplePayIntegrationStatusState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
        },
      };
    case actionConstants.GET_APPLE_PAY_INTEGRATION_STATUS_SUCCESS:
      return {
        ...state,
        getApplePayIntegrationStatusState: {
          ...state.getApplePayIntegrationStatusState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
          // errorCode: action.payload.OpCode,
        },
      };
    case actionConstants.GET_APPLE_PAY_INTEGRATION_STATUS_FAILURE:
      return {
        ...state,
        getApplePayIntegrationStatusState: {
          ...state.getApplePayIntegrationStatusState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          // errorCode: action.payload.OpCode,
        },
      };
    case actionConstants.GET_APPLE_PAY_INTEGRATION_STATUS_CLEAR:
      return {
        ...state,
        getApplePayIntegrationStatusState: {
          ...initialState.getApplePayIntegrationStatusState,
          data: {},
        },
      };

    case actionConstants.GET_APPLE_PAY_WALLET_STATUS_REQUEST:
      return {
        ...state,
        getApplePayWalletStatusState: {
          ...state.getApplePayWalletStatusState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
        },
      };
    case actionConstants.GET_APPLE_PAY_WALLET_STATUS_SUCCESS:
      return {
        ...state,
        getApplePayWalletStatusState: {
          ...state.getApplePayWalletStatusState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
          // errorCode: action.payload.OpCode,
        },
      };
    case actionConstants.GET_APPLE_PAY_WALLET_STATUS_FAILURE:
      return {
        ...state,
        getApplePayWalletStatusState: {
          ...state.getApplePayWalletStatusState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          // errorCode: action.payload.OpCode,
        },
      };
    case actionConstants.GET_APPLE_PAY_WALLET_STATUS_CLEAR:
      return {
        ...state,
        getApplePayWalletStatusState: {
          ...initialState.getApplePayWalletStatusState,
          data: {},
        },
      };
  
   
    case actionConstants.GET_DOWNLOAD_CSR_APPLE_PAY_REQUEST:
      return {
        ...state,
        downloadCsrApplePayState: {
          ...state.downloadCsrApplePayState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
        },
      };
    case actionConstants.GET_DOWNLOAD_CSR_APPLE_PAY_SUCCESS:
      return {
        ...state,
        downloadCsrApplePayState: {
          ...state.downloadCsrApplePayState,
          isLoading: false,
          isSuccess: true,
          isFailure: false, 
          data: action.payload.body,
          // errorCode: action.payload.OpCode,
        },
      };
    case actionConstants.GET_DOWNLOAD_CSR_APPLE_PAY_FAILURE:
      return {
        ...state,
        downloadCsrApplePayState: {
          ...state.downloadCsrApplePayState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          // errorCode: action.payload.OpCode,
        },
      };
    case actionConstants.GET_DOWNLOAD_CSR_APPLE_PAY_CLEAR:
      return {
        ...state,
        downloadCsrApplePayState: {
          ...initialState.downloadCsrApplePayState,
          data: {},
        },
      };

    case actionConstants.GET_CHECKOUT_VERSION_REQUEST:
      return {
        ...state,
        getCheckoutVersionState: {
          ...state.getCheckoutVersionState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
        },
      };
    case actionConstants.GET_CHECKOUT_VERSION_SUCCESS:
      return {
        ...state,
        getCheckoutVersionState: {
          ...state.getCheckoutVersionState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
          // errorCode: action.payload.OpCode,
        },
      };
    case actionConstants.GET_CHECKOUT_VERSION_FAILURE:
      return {
        ...state,
        getCheckoutVersionState: {
          ...state.getCheckoutVersionState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          // errorCode: action.payload.OpCode,
        },
      };
    case actionConstants.GET_CHECKOUT_VERSION_CLEAR:
      return {
        ...state,
        getCheckoutVersionState: {
          ...initialState.getCheckoutVersionState,
          data: {},
        },
      };

    case actionConstants.GET_HAS_MERCHANT_TRANSACTED_REQUEST:
      return {
        ...state,
        hasMerchantTransactedState: {
          ...state.hasMerchantTransactedState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
        },
      };
    case actionConstants.GET_HAS_MERCHANT_TRANSACTED_SUCCESS:
      return {
        ...state,
        hasMerchantTransactedState: {
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          hasTransacted: action.payload.body?.hasTransacted ?? false,
        },
      };
    case actionConstants.GET_HAS_MERCHANT_TRANSACTED_FAILURE:
      return {
        ...state,
        hasMerchantTransactedState: {
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          hasTransacted: null,
        },
      };
    case actionConstants.GET_ACTIVE_WEBHOOK_EVENTS_REQUEST:
      return {
        ...state,
        activeWebhookEvents: {
          ...state.activeWebhookEvents,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
        },
      };

    case actionConstants.GET_ACTIVE_WEBHOOK_EVENTS_SUCCESS:
      return {
        ...state,
        activeWebhookEvents: {
          ...state.activeWebhookEvents,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
          // errorCode: action.payload.OpCode,
        },
      };

    case actionConstants.GET_ACTIVE_WEBHOOK_EVENTS_FAILURE:
      return {
        ...state,
        activeWebhookEvents: {
          ...state.activeWebhookEvents,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          // errorCode: action.payload.OpCode,
        },
      };

    case actionConstants.GET_ACTIVE_WEBHOOK_EVENTS_CLEAR:
      return {
        ...state,
        activeWebhookEvents: {
          ...initialState.activeWebhookEvents,
          data: {},
        },
      };

    case actionConstants.GET_MERCHENT_SETTINGS_REQUEST:
      return {
        ...state,
        merchentSettings: {
          ...state.merchentSettings,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
        },
      };

    case actionConstants.GET_MERCHENT_SETTINGS_SUCCESS:
      return {
        ...state,
        merchentSettings: {
          ...state.merchentSettings,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
          // errorCode: action.payload.OpCode,
        },
      };

    case actionConstants.GET_MERCHENT_SETTINGS_FAILURE:
      return {
        ...state,
        merchentSettings: {
          ...state.merchentSettings,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          // errorCode: action.payload.OpCode,
        },
      };

    case actionConstants.GET_MERCHENT_SETTINGS_CLEAR:
      return {
        ...state,
        merchentSettings: {
          ...initialState.merchentSettings,
          data: {},
        },
      };

    case actionConstants.UPDATE_MERCHENT_GENERAL_SETTINGS_REQUEST:
      return {
        ...state,
        updateGeneralSettings: {
          ...state.updateGeneralSettings,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
        },
      };

    case actionConstants.UPDATE_MERCHENT_GENERAL_SETTINGS_SUCCESS:
      return {
        ...state,
        updateGeneralSettings: {
          ...state.updateGeneralSettings,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
          // errorCode: action.payload.OpCode,
        },
      };

    case actionConstants.UPDATE_MERCHENT_GENERAL_SETTINGS_FAILURE:
      return {
        ...state,
        updateGeneralSettings: {
          ...state.updateGeneralSettings,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          // errorCode: action.payload.OpCode,
        },
      };

    case actionConstants.UPDATE_MERCHENT_GENERAL_SETTINGS_CLEAR:
      return {
        ...state,
        updateGeneralSettings: {
          ...initialState.updateGeneralSettings,
          data: {},
        },
      };

    case actionConstants.UPDATE_MERCHENT_WEBHOOK_REQUEST:
      return {
        ...state,
        updateMerchentWebhook: {
          ...state.updateMerchentWebhook,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
        },
      };

    case actionConstants.UPDATE_MERCHENT_WEBHOOK_SUCCESS:
      return {
        ...state,
        updateMerchentWebhook: {
          ...state.updateMerchentWebhook,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
          // errorCode: action.payload.OpCode,
        },
      };

    case actionConstants.UPDATE_MERCHENT_WEBHOOK_FAILURE:
      return {
        ...state,
        updateMerchentWebhook: {
          ...state.updateMerchentWebhook,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          // errorCode: action.payload.OpCode,
        },
      };

    case actionConstants.UPDATE_MERCHENT_WEBHOOK_CLEAR:
      return {
        ...state,
        updateMerchentWebhook: {
          ...initialState.updateMerchentWebhook,
          data: {},
        },
      };

    case actionConstants.GET_V3_MERCHANT_WEBHOOK_REQUEST:
      return {
        ...state,
        v3MerchantWebhook: {
          ...state.v3MerchantWebhook,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
        },
      };

    case actionConstants.GET_V3_MERCHANT_WEBHOOK_SUCCESS:
      return {
        ...state,
        v3MerchantWebhook: {
          ...state.v3MerchantWebhook,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
        },
      };

    case actionConstants.GET_V3_MERCHANT_WEBHOOK_FAILURE:
      return {
        ...state,
        v3MerchantWebhook: {
          ...state.v3MerchantWebhook,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          errorMessage:
            action.payload?.body?.errorMessage ||
            action.payload?.body?.error_message ||
            action.payload?.body?.message ||
            '',
        },
      };

    case actionConstants.GET_V3_MERCHANT_WEBHOOK_CLEAR:
      return {
        ...state,
        v3MerchantWebhook: {
          ...initialState.v3MerchantWebhook,
          data: {},
        },
      };

    case actionConstants.UPDATE_V3_MERCHANT_WEBHOOK_REQUEST:
      return {
        ...state,
        updateV3MerchantWebhook: {
          ...state.updateV3MerchantWebhook,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
        },
      };

    case actionConstants.UPDATE_V3_MERCHANT_WEBHOOK_SUCCESS:
      return {
        ...state,
        updateV3MerchantWebhook: {
          ...state.updateV3MerchantWebhook,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
        },
      };

    case actionConstants.UPDATE_V3_MERCHANT_WEBHOOK_FAILURE:
      return {
        ...state,
        updateV3MerchantWebhook: {
          ...state.updateV3MerchantWebhook,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          errorMessage:
            action.payload?.body?.errorMessage ||
            action.payload?.body?.error_message ||
            action.payload?.body?.message ||
            '',
        },
      };

    case actionConstants.UPDATE_V3_MERCHANT_WEBHOOK_CLEAR:
      return {
        ...state,
        updateV3MerchantWebhook: {
          ...initialState.updateV3MerchantWebhook,
          data: {},
        },
      };

    case actionConstants.GET_ACTIVE_USERS_LIST_REQUEST:
      return {
        ...state,
        activeUsersList: {
          ...state.activeUsersList,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
        },
      };

    case actionConstants.GET_ACTIVE_USERS_LIST_SUCCESS:
      return {
        ...state,
        activeUsersList: {
          ...state.activeUsersList,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
          // errorCode: action.payload.OpCode,
          activeUserCount: action.payload?.body?.active_user_count ?? 0,
        },
      };

    case actionConstants.GET_ACTIVE_USERS_LIST_FAILURE:
      return {
        ...state,
        activeUsersList: {
          ...state.activeUsersList,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          // errorCode: action.payload.OpCode,
        },
      };

    case actionConstants.GET_ACTIVE_USERS_LIST_CLEAR:
      return {
        ...state,
        activeUsersList: {
          ...activeUsers,
          data: {},
        },
      };

    case actionConstants.GET_ALL_ROLES_REQUEST:
      return {
        ...state,
        allRoles: {
          ...state.allRoles,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
        },
      };

    case actionConstants.GET_ALL_ROLES_SUCCESS:
      return {
        ...state,
        allRoles: {
          ...state.allRoles,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
          // errorCode: action.payload.OpCode,
        },
      };

    case actionConstants.GET_ALL_ROLES_FAILURE:
      return {
        ...state,
        allRoles: {
          ...state.allRoles,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          // errorCode: action.payload.OpCode,
        },
      };

    case actionConstants.GET_ALL_ROLES_CLEAR:
      return {
        ...state,
        allRoles: {
          ...allRoles,
        },
      };

    case actionConstants.GET_ALL_PERMISSIONS_LIST_REQUEST:
      return {
        ...state,
        allPermissions: {
          ...state.allPermissions,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
        },
      };

    case actionConstants.GET_ALL_PERMISSIONS_LIST_SUCCESS:
      return {
        ...state,
        allPermissions: {
          ...state.allPermissions,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
          // errorCode: action.payload.OpCode,
        },
      };

    case actionConstants.GET_ALL_PERMISSIONS_LIST_FAILURE:
      return {
        ...state,
        allPermissions: {
          ...state.allPermissions,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          // errorCode: action.payload.OpCode,
        },
      };

    case actionConstants.GET_ALL_PERMISSIONS_LIST_CLEAR:
      return {
        ...state,
        allPermissions: {
          ...allPermissions,
        },
      };

    case actionConstants.POST_CREATE_NEW_USER_REQUEST:
      return {
        ...state,
        createNewUserState: {
          ...state.createNewUserState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
        },
      };

    case actionConstants.POST_CREATE_NEW_USER_SUCCESS:
      return {
        ...state,
        createNewUserState: {
          ...state.createNewUserState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
          assignedRoleId: action.payload.extra?.assignedRoleId ?? '',
          // errorCode: action.payload.OpCode,
        },
      };

    case actionConstants.POST_CREATE_NEW_USER_FAILURE:
      return {
        ...state,
        createNewUserState: {
          ...state.createNewUserState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          data: action.payload.body,
          // errorCode: action.payload.OpCode,
        },
      };

    case actionConstants.POST_CREATE_NEW_USER_CLEAR:
      return {
        ...state,
        createNewUserState: {
          ...createNewUserState,
        },
      };

    case actionConstants.POST_CREATE_NEW_ROLE_REQUEST:
      return {
        ...state,
        createNewRoleState: {
          ...state.createNewRoleState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
          responseCode: 0,
        },
      };

    case actionConstants.POST_CREATE_NEW_ROLE_SUCCESS:
      return {
        ...state,
        createNewRoleState: {
          ...state.createNewRoleState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
          responseCode: action.payload?.body?.RESPONSE_CODE ?? 0,
        },
      };

    case actionConstants.POST_CREATE_NEW_ROLE_FAILURE:
      return {
        ...state,
        createNewRoleState: {
          ...state.createNewRoleState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          responseCode: action.payload?.body?.RESPONSE_CODE ?? 0,
        },
      };

    case actionConstants.POST_CREATE_NEW_ROLE_CLEAR:
      return {
        ...state,
        createNewRoleState: {
          ...createNewRoleState,
        },
      };

    case actionConstants.POST_UPDATE_USER_DETAILS_REQUEST:
      return {
        ...state,
        updateUserState: {
          ...state.updateUserState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
        },
      };

    case actionConstants.POST_UPDATE_USER_DETAILS_SUCCESS:
      return {
        ...state,
        updateUserState: {
          ...state.updateUserState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
          // errorCode: action.payload.OpCode,
        },
      };

    case actionConstants.POST_UPDATE_USER_DETAILS_FAILURE:
      return {
        ...state,
        updateUserState: {
          ...state.updateUserState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          // errorCode: action.payload.OpCode,
        },
      };

    case actionConstants.POST_UPDATE_USER_DETAILS_CLEAR:
      return {
        ...state,
        updateUserState: {
          ...updateUserState,
        },
      };

    case actionConstants.DELETE_USER_REQUEST:
      return {
        ...state,
        deleteUserState: {
          ...state.deleteUserState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
        },
      };

    case actionConstants.DELETE_USER_SUCCESS:
      return {
        ...state,
        deleteUserState: {
          ...state.deleteUserState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
          // errorCode: action.payload.OpCode,
        },
      };

    case actionConstants.DELETE_USER_FAILURE:
      return {
        ...state,
        deleteUserState: {
          ...state.deleteUserState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          // errorCode: action.payload.OpCode,
        },
      };

    case actionConstants.DELETE_USER_CLEAR:
      return {
        ...state,
        deleteUserState: {
          ...deleteUserState,
        },
      };

    case actionConstants.POST_RESEND_INVITATION_REQUEST:
      return {
        ...state,
        resendInvitationState: {
          ...state.resendInvitationState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
        },
      };

    case actionConstants.POST_RESEND_INVITATION_SUCCESS:
      return {
        ...state,
        resendInvitationState: {
          ...state.resendInvitationState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
        },
      };

    case actionConstants.POST_RESEND_INVITATION_FAILURE:
      return {
        ...state,
        resendInvitationState: {
          ...state.resendInvitationState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          errorMessage: action.payload?.body?.error_message,
        },
      };

    case actionConstants.POST_RESEND_INVITATION_CLEAR:
      return {
        ...state,
        resendInvitationState: {
          ...resendInvitationState,
        },
      };

    case actionConstants.GET_CHECKOUT_THEME_REQUEST:
      return {
        ...state,
        getCheckoutThemeState: {
          ...state.getCheckoutThemeState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
        },
      };

    case actionConstants.GET_CHECKOUT_THEME_SUCCESS:
      return {
        ...state,
        getCheckoutThemeState: {
          ...state.getCheckoutThemeState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
          // errorCode: action.payload.OpCode,
        },
      };

    case actionConstants.GET_CHECKOUT_THEME_FAILURE:
      return {
        ...state,
        getCheckoutThemeState: {
          ...state.getCheckoutThemeState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          // errorCode: action.payload.OpCode,
        },
      };

    case actionConstants.GET_CHECKOUT_THEME_CLEAR:
      return {
        ...state,
        getCheckoutThemeState: {
          ...getCheckoutThemeState,
        },
      };

    case actionConstants.POST_UPDATE_CHECKOUT_THEME_REQUEST:
      return {
        ...state,
        updateCheckoutThemeState: {
          ...state.updateCheckoutThemeState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
        },
      };

    case actionConstants.POST_UPDATE_CHECKOUT_THEME_SUCCESS:
      return {
        ...state,
        updateCheckoutThemeState: {
          ...state.updateCheckoutThemeState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
          // errorCode: action.payload.OpCode,
        },
      };

    case actionConstants.POST_UPDATE_CHECKOUT_THEME_FAILURE:
      return {
        ...state,
        updateCheckoutThemeState: {
          ...state.updateCheckoutThemeState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          // errorCode: action.payload.OpCode,
        },
      };

    case actionConstants.POST_UPDATE_CHECKOUT_THEME_CLEAR:
      return {
        ...state,
        updateCheckoutThemeState,
      };

    case actionConstants.GET_DASHBOARD_THEME_REQUEST:
      return {
        ...state,
        getDashboardThemeState: {
          ...state.getDashboardThemeState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
          errorMessage: '',
        },
      };

    case actionConstants.GET_DASHBOARD_THEME_SUCCESS:
      return {
        ...state,
        getDashboardThemeState: {
          ...state.getDashboardThemeState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
        },
      };

    case actionConstants.GET_DASHBOARD_THEME_FAILURE:
      return {
        ...state,
        getDashboardThemeState: {
          ...state.getDashboardThemeState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          errorCode:
            action.payload?.errorCode ?? action.payload?.body?.error_code,
          errorMessage:
            action.payload?.errorMessage ?? action.payload?.body?.error_message,
        },
      };

    case actionConstants.GET_DASHBOARD_THEME_CLEAR:
      return {
        ...state,
        getDashboardThemeState,
      };

    case actionConstants.POST_UPDATE_DASHBOARD_THEME_REQUEST:
      return {
        ...state,
        updateDashboardThemeState: {
          ...state.updateDashboardThemeState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
          errorMessage: '',
        },
      };

    case actionConstants.POST_UPDATE_DASHBOARD_THEME_SUCCESS:
      return {
        ...state,
        updateDashboardThemeState: {
          ...state.updateDashboardThemeState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
        },
      };

    case actionConstants.POST_UPDATE_DASHBOARD_THEME_FAILURE:
      return {
        ...state,
        updateDashboardThemeState: {
          ...state.updateDashboardThemeState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          errorCode:
            action.payload?.errorCode ?? action.payload?.body?.error_code,
          errorMessage:
            action.payload?.errorMessage ?? action.payload?.body?.error_message,
        },
      };

    case actionConstants.POST_UPDATE_DASHBOARD_THEME_CLEAR:
      return {
        ...state,
        updateDashboardThemeState,
      };

    case actionConstants.PUT_UPDATE_MERCHANT_TPV_REQUEST:
      return {
        ...state,
        updateTPVState: {
          ...state.updateTPVState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          opCode: 0,
        },
      };

    case actionConstants.PUT_UPDATE_MERCHANT_TPV_SUCCESS:
      return {
        ...state,
        updateTPVState: {
          ...state.updateTPVState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          opCode: action.payload?.body?.response_code ?? 0,
        },
      };

    case actionConstants.PUT_UPDATE_MERCHANT_TPV_FAILURE:
      return {
        ...state,
        updateTPVState: {
          ...state.updateTPVState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          opCode: action.payload?.body?.response_code ?? 0,
        },
      };

    case actionConstants.PUT_UPDATE_MERCHANT_TPV_CLEAR:
      return {
        ...state,
        updateTPVState,
      };

    // Case Management Reducers
    case actionConstants.GET_CASE_MANAGEMENT_AUTH_REQUEST:
      return {
        ...state,
        caseManagementState: {
          ...caseManagementState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
        },
      };

    case actionConstants.GET_CASE_MANAGEMENT_AUTH_SUCCESS:
      return {
        ...state,
        caseManagementState: {
          ...caseManagementState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
        },
      };

    case actionConstants.FETCH_OFFERS_RULE_REQUEST:
      return {
        ...state,
        fetchOffersRule: {
          ...state.fetchOffersRule,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
        },
      };

    case actionConstants.FETCH_OFFERS_RULE_SUCCESS:
      return {
        ...state,
        fetchOffersRule: {
          ...state.fetchOffersRule,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          errorCode: 0,
          data: action.payload.body,
        },
      };

    case actionConstants.GET_CASE_MANAGEMENT_AUTH_FAILURE:
      return {
        ...state,
        caseManagementState: {
          ...caseManagementState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          data: {},
          error_message: action.payload.body,
        },
      };

    case actionConstants.GET_TICKET_LIST_REQUEST:
      return {
        ...state,
        ticketListState: {
          ...ticketListState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
        },
      };

    case actionConstants.FETCH_OFFERS_RULE_FAILURE:
      return {
        ...state,
        fetchOffersRule: {
          ...state.fetchOffersRule,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          // errorCode: action.payload.OpCode,
          errorMessage: action.payload?.body?.error_message ?? '',
        },
      };

    case actionConstants.FETCH_OFFERS_RULE_CLEAR:
      return {
        ...state,
        fetchOffersRule: {
          ...initialState.fetchOffersRule,
          data: {},
          isLoading: false,
          isSuccess: false,
          isFailure: false,
        },
      };

    case actionConstants.GET_TICKET_LIST_SUCCESS:
      return {
        ...state,
        ticketListState: {
          ...ticketListState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
        },
      };

    case actionConstants.SET_OFFERS_RULE_REQUEST:
      return {
        ...state,
        setOffersRule: {
          ...state.setOffersRule,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
        },
      };

    case actionConstants.SET_OFFERS_RULE_SUCCESS:
      return {
        ...state,
        setOffersRule: {
          ...state.setOffersRule,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          errorCode: 0,
          data: action.payload.body,
        },
      };

    case actionConstants.GET_TICKET_LIST_FAILURE:
      return {
        ...state,
        ticketListState: {
          ...ticketListState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          data: {},
          error_message: action.payload.body,
        },
      };

    case actionConstants.GET_TICKET_DETAIL_REQUEST:
      return {
        ...state,
        ticketDetailState: {
          ...ticketDetailState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
        },
      };
    case actionConstants.SET_OFFERS_RULE_FAILURE:
      return {
        ...state,
        setOffersRule: {
          ...state.setOffersRule,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          // errorCode: action.payload.OpCode,
          errorMessage: action.payload?.body?.error_message ?? '',
        },
      };

    case actionConstants.SET_OFFERS_RULE_CLEAR:
      return {
        ...state,
        setOffersRule: {
          ...initialState.setOffersRule,
          data: {},
          isLoading: false,
          isSuccess: false,
          isFailure: false,
        },
      };

    case actionConstants.GET_TICKET_DETAIL_SUCCESS:
      return {
        ...state,
        ticketDetailState: {
          ...ticketDetailState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
        },
      };

    case actionConstants.GET_TICKET_DETAIL_FAILURE:
      return {
        ...state,
        ticketDetailState: {
          ...ticketDetailState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          data: {},
          error_message: action.payload.body,
        },
      };

    case actionConstants.GET_CATEGORY_REQUEST:
      return {
        ...state,
        categoryListState: {
          ...categoryListState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
        },
      };

    case actionConstants.GET_CATEGORY_SUCCESS:
      return {
        ...state,
        categoryListState: {
          ...categoryListState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body.data,
        },
      };

    case actionConstants.GET_CATEGORY_FAILURE:
      return {
        ...state,
        categoryListState: {
          ...categoryListState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          data: {},
          error_message: action.payload.body,
        },
      };

    case actionConstants.GET_SUBCATEGORY_REQUEST:
      return {
        ...state,
        subcategoryListState: {
          ...subcategoryListState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
        },
      };

    case actionConstants.GET_SUBCATEGORY_SUCCESS:
      return {
        ...state,
        subcategoryListState: {
          ...subcategoryListState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body.data,
        },
      };

    case actionConstants.GET_SUBCATEGORY_FAILURE:
      return {
        ...state,
        subcategoryListState: {
          ...subcategoryListState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          data: {},
          error_message: action.payload.body,
        },
      };

    case actionConstants.GET_UPLOAD_DOCUMENTS_REQUEST:
      return {
        ...state,
        uploadDocumentState: {
          ...uploadDocumentState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
        },
      };

    case actionConstants.GET_UPLOAD_DOCUMENTS_SUCCESS:
      return {
        ...state,
        uploadDocumentState: {
          ...uploadDocumentState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
        },
      };

    case actionConstants.GET_UPLOAD_DOCUMENTS_FAILURE:
      return {
        ...state,
        uploadDocumentState: {
          ...uploadDocumentState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          data: {},
          error_message: action.payload.body,
        },
      };

    case actionConstants.GET_CREATE_TICKET_REQUEST:
      return {
        ...state,
        createTicketState: {
          ...createTicketState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
        },
      };

    case actionConstants.GET_CREATE_TICKET_SUCCESS:
      return {
        ...state,
        createTicketState: {
          ...createTicketState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
        },
      };

    case actionConstants.GET_CREATE_TICKET_FAILURE:
      return {
        ...state,
        createTicketState: {
          ...createTicketState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          data: {},
          error_message: action.payload.body,
        },
      };

    case actionConstants.GET_CREATE_TICKET_CLEAR:
      return {
        ...state,
        createTicketState,
      };

    case actionConstants.GET_LINK_DOCUMENTS_TO_TICKETS_REQUEST:
      return {
        ...state,
        linkDocumentTicketState: {
          ...linkDocumentTicketState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
        },
      };

    case actionConstants.GET_LINK_DOCUMENTS_TO_TICKETS_SUCCESS:
      return {
        ...state,
        linkDocumentTicketState: {
          ...linkDocumentTicketState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
        },
      };

    case actionConstants.GET_LINK_DOCUMENTS_TO_TICKETS_FAILURE:
      return {
        ...state,
        linkDocumentTicketState: {
          ...linkDocumentTicketState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          data: {},
          error_message: action.payload.body,
        },
      };

    case actionConstants.GET_ALL_COMMENTS_REQUEST:
      return {
        ...state,
        caseCommentState: {
          ...caseCommentState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
        },
      };

    case actionConstants.GET_ALL_COMMENTS_SUCCESS:
      return {
        ...state,
        caseCommentState: {
          ...caseCommentState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
        },
      };

    case actionConstants.GET_ALL_COMMENTS_FAILURE:
      return {
        ...state,
        caseCommentState: {
          ...caseCommentState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          data: {},
          error_message: action.payload.body,
        },
      };

    case actionConstants.ADD_COMMENTS_REQUEST:
      return {
        ...state,
        addCommentState: {
          ...addCommentState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
        },
      };

    case actionConstants.ADD_COMMENTS_SUCCESS:
      return {
        ...state,
        addCommentState: {
          ...addCommentState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
        },
      };

    case actionConstants.ADD_COMMENTS_FAILURE:
      return {
        ...state,
        addCommentState: {
          ...addCommentState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          data: {},
          error_message: action.payload.body,
        },
      };

    case actionConstants.GET_ALL_ATTACHMENTS_REQUEST:
      return {
        ...state,
        attachmentDetailState: {
          ...attachmentDetailState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
        },
      };

    case actionConstants.GET_ALL_ATTACHMENTS_SUCCESS:
      return {
        ...state,
        attachmentDetailState: {
          ...attachmentDetailState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
        },
      };

    case actionConstants.GET_ALL_ATTACHMENTS_FAILURE:
      return {
        ...state,
        attachmentDetailState: {
          ...attachmentDetailState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          data: {},
          error_message: action.payload.body,
        },
      };

    case actionConstants.GET_ACTIVE_EDGE_PAYMENTS_LINKS_WEBHOOK_EVENTS_REQUEST:
      return {
        ...state,
        activeEdgePaymentLinksEvents: {
          ...state.activeEdgePaymentLinksEvents,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
        },
      };

    case actionConstants.GET_ACTIVE_EDGE_PAYMENTS_LINKS_WEBHOOK_EVENTS_SUCCESS:
      return {
        ...state,
        activeEdgePaymentLinksEvents: {
          ...state.activeEdgePaymentLinksEvents,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
          // errorCode: action.payload.OpCode,
        },
      };

    case actionConstants.GET_ACTIVE_EDGE_PAYMENTS_LINKS_WEBHOOK_EVENTS_FAILURE:
      return {
        ...state,
        activeEdgePaymentLinksEvents: {
          ...state.activeEdgePaymentLinksEvents,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          // errorCode: action.payload.OpCode,
        },
      };

    case actionConstants.GET_ACTIVE_EDGE_PAYMENTS_LINKS_WEBHOOK_EVENTS_CLEAR:
      return {
        ...state,
        activeEdgePaymentLinksEvents: {
          ...initialState.activeEdgePaymentLinksEvents,
          data: {},
        },
      };

    case actionConstants.UPDATE_EDGE_PAYMENT_LINKS_WEBHOOK_REQUEST:
      return {
        ...state,
        updateEdgePaymentLinksWebhook: {
          ...state.updateEdgePaymentLinksWebhook,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
        },
      };

    case actionConstants.UPDATE_EDGE_PAYMENT_LINKS_WEBHOOK_SUCCESS:
      return {
        ...state,
        updateEdgePaymentLinksWebhook: {
          ...state.updateEdgePaymentLinksWebhook,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
          // errorCode: action.payload.OpCode,
        },
      };

    case actionConstants.UPDATE_EDGE_PAYMENT_LINKS_WEBHOOK_FAILURE:
      return {
        ...state,
        updateEdgePaymentLinksWebhook: {
          ...state.updateEdgePaymentLinksWebhook,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          // errorCode: action.payload.OpCode,
        },
      };

    case actionConstants.UPDATE_EDGE_PAYMENT_LINKS_WEBHOOK_CLEAR:
      return {
        ...state,
        updateEdgePaymentLinksWebhook: {
          ...initialState.updateEdgePaymentLinksWebhook,
          data: {},
        },
      };

    case actionConstants.POST_UPDATE_MERCHANT_VERSION_REQUEST:
      return {
        ...state,
        updateMerchantVersionData: {
          ...state.updateMerchantVersionData,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
          activeRequestId: action.payload?.requestId ?? '',
        },
      };

    case actionConstants.POST_UPDATE_MERCHANT_VERSION_SUCCESS:
      if (
        isStaleResponse(
          state.updateMerchantVersionData.activeRequestId,
          action.payload?.extra?.requestId
        )
      ) {
        return state;
      }
      return {
        ...state,
        updateMerchantVersionData: {
          ...state.updateMerchantVersionData,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
          activeRequestId: '',
          // errorCode: action.payload.OpCode,
        },
      };

    case actionConstants.POST_UPDATE_MERCHANT_VERSION_FAILURE:
      if (
        isStaleResponse(
          state.updateMerchantVersionData.activeRequestId,
          action.payload?.extra?.requestId
        )
      ) {
        return state;
      }
      return {
        ...state,
        updateMerchantVersionData: {
          ...state.updateMerchantVersionData,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          errorMessage: action.payload?.body?.error_message,
          activeRequestId: '',
        },
      };

    case actionConstants.POST_UPDATE_MERCHANT_VERSION_CLEAR:
      return {
        ...state,
        updateMerchantVersionData: {
          ...initialState.updateMerchantVersionData,
          data: {},
          activeRequestId: CLEARED_REQUEST_ID,
        },
      };

    default:
      return state;
  }
}
